import fs from 'node:fs';
import path from 'node:path';
import { fileURLToPath } from 'node:url';

let cachedVersion: string | undefined;

/** Version of the running CLI, read once from its own package.json. */
export function cliVersion(): string {
  if (cachedVersion === undefined) {
    try {
      const pkgPath = path.resolve(
        path.dirname(fileURLToPath(import.meta.url)),
        '..',
        'package.json',
      );
      cachedVersion = (JSON.parse(fs.readFileSync(pkgPath, 'utf8')) as { version: string }).version;
    } catch {
      cachedVersion = '0.0.0';
    }
  }
  return cachedVersion;
}

/**
 * Numeric x.y.z compare; prerelease/build suffixes are ignored ("0.17.0-beta"
 * sorts equal to "0.17.0"). Deliberately duplicated server-side in the
 * admin-app CLI version gate — both copies stay trivially small rather than
 * sharing a package across the npm publish boundary. Keep them in sync.
 */
export function compareSemver(a: string, b: string): -1 | 0 | 1 {
  const pa = numbers(a);
  const pb = numbers(b);
  for (let i = 0; i < 3; i++) {
    if (pa[i] !== pb[i]) return pa[i] > pb[i] ? 1 : -1;
  }
  return 0;
}

function numbers(version: string): [number, number, number] {
  const [x, y, z] = version
    .trim()
    .replace(/^v/, '')
    .split('.', 3)
    .map((part) => Number.parseInt(part, 10));
  return [x || 0, y || 0, z || 0];
}
